<template>
    <div>
        <my-search v-model="pgData" @search="searchHandler">
            <el-form-item slot="title">
                <el-input v-model="pgData.txtKey"  placeholder="公告名称" clearable></el-input>
            </el-form-item>
            <el-form-item slot="time">
                <el-input v-model="pgData.txtKey1"  placeholder="添加人" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-radio-group v-model="pgData.txtKey2" @change="searchHandler">
                    <el-radio-button label="1">未审核公告</el-radio-button>
                    <el-radio-button label="9">已审核公告</el-radio-button>
                </el-radio-group>
            </el-form-item>
        </my-search>
        <!--提示-->
        <my-tag type="danger" style="font-size:16px;margin-bottom:10px;">
            <div class="reason">
                注意：因招标公告及相关数据，推送至招标投标公共服务平台或招标投标行政监督平台（招管通）需要一定时间，为了不影响招标公告的发布，建议16:30之前进行审核
            </div>
        </my-tag>

        <my-table :data="tableData" :height="tableHeight">
            <el-table-column label="公告名称" prop="ggname" min-width="220" fixed="left"></el-table-column>
            <el-table-column label="公告性质" prop="ggxzname" width="120"></el-table-column>
            <el-table-column label="公告类型" prop="gglxname" sortable width="120"></el-table-column>
            <el-table-column label="添加人" prop="addusername" sortable width="150"></el-table-column>
            <el-table-column label="添加时间" prop="addtime" sortable width="150"></el-table-column>
            <el-table-column label="公告发布时间" prop="ggfbtime" sortable width="150"></el-table-column>
            <el-table-column label="审核日期" prop="audittime" sortable width="150"></el-table-column>
            <el-table-column label="公共服务平台同步状态" width="170">
                <template slot-scope="scope">
                    <state-list :row="scope.row" :config="STATEPT_CONF"></state-list>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <div v-if="scope.row.shbj!=='3'">
                        <state-list 
                        :row="scope.row" 
                        :config="STATE_CONF" 
                        @reload="reloadHandler">
                        </state-list> 
                    </div>
                    <my-tag type="danger" v-if="scope.row.shbj==='3'" style="height:auto">
                        <div style="white-space:pre-wrap">
                            退回：{{scope.row.by2}}
                        </div>    
                    </my-tag>
                    
                </template>
            </el-table-column>
            <el-table-column label="查看关联信息" prop="audittime" width="150">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document" @click="jumpUrl('project',scope.row.ggcode)">项目信息</el-button>
                    <el-button type="text" icon="el-icon-document" @click="jumpUrl('zbproject',scope.row.ggcode)">招标项目信息</el-button>
                    <el-button type="text" icon="el-icon-document" @click="jumpUrl('zbwj',scope.row.ggcode)">招标文件信息</el-button>
                </template>
            </el-table-column>
            <el-table-column label="操作" min-width="150" fixed="right">
                <template slot-scope="scope">
                    <btn-list 
                        :row="scope.row"
                        @reload="reloadHandler"
                        :config="BTN_CONF">
                    </btn-list>
                </template>
            </el-table-column>
        </my-table>
        <my-pagination ref="page" v-model="tableData" :search="pgData" :action="`${getGetters('mngUrl')}/manage/business/AuditZbgg/get_list.json`">
        </my-pagination>

    </div>
</template>

<script>

import LIST_PAGE_MIXIN from '@views/mixins/list-page'

import FormAudit from './sub-pages/form-audit'
import FormTbzt from './sub-pages/form-tbzt'

import STATE_CONF from './config/zbgg-state'
import STATEPT_CONF from './config/zbggpt-state'
import BTN_CONF from './config/zbgg-btn-list'

export default {
    mixins: [LIST_PAGE_MIXIN],
    components: {
        FormAudit,FormTbzt
    },
    data() {
        return{
            pgData: {
                txtKey:'',
                txtKey1:'',
                txtKey2: '1',
                sortname: 'addtime',
            },

            STATE_CONF,
            STATEPT_CONF,
            BTN_CONF,
        }
    },
    computed: {
        
    },
    watch: {
     
    },
    methods: {
        
        // 跳转详情页面
        jumpUrl(val,ggcode){
            this.goto({
                path: '/iframe',
                query: {
                    content: val,
                    ggcode:ggcode,
                    url:'/Zbdl/AuditZbgg/checkall.do'
                }
            });
        },

    },
    created() {
        
    },
    mounted() {
        
    }
}
</script>

<style scoped lang="scss">
    
</style>
